export default "__VITE_ASSET__BDATxPOV__"